import { render, staticRenderFns } from "./QuestionsComponent.vue?vue&type=template&id=0def0976&scoped=true"
import script from "./QuestionsComponent.vue?vue&type=script&lang=js"
export * from "./QuestionsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def0976",
  null
  
)

export default component.exports